import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
    name: "graduate-work-rules",
    created() {
        this.changeHeader({
            show: true,
            title: this.$t("graduateWorkRulesLabel"),
            parentRoute: {
                name: "courses-main",
                params: { item: this.$route.params.item },
            },
        });
        console.log(this.$route);
        if (!this.currentItem) {
            this.fetchData({
                courseSlug: this.$route.params.item,
            })
                .then(() => {
                    this.checkStatusTest();
                })
                .catch((error) => {
                    if (error.response.status === 403) {
                        // this.$toasted.error(error.response.data.error.message_key)
                        try {
                            this.$router.push({
                                name: "courses-main",
                                params: { item: this.$route.params.item },
                            });
                        } catch (e) {
                            console.log(e);
                        }
                    }
                });
        } else {
            this.checkStatusTest();
        }
    },
    beforeRouteLeave(to, from, next) {
        this.setItem(null);
        next();
    },
    computed: {
        ...mapGetters({
            isLoading: "coursesGraduateWork/isLoading",
            currentItem: "coursesGraduateWork/currentItem",
        }),
    },
    methods: {
        ...mapActions({
            fetchData: "coursesGraduateWork/GET_LIST_ITEM",
        }),
        ...mapMutations({
            changeHeader: "coursesGraduateWork/CHANGE_HEADER",
            setItem: "coursesGraduateWork/SET_ITEM",
        }),
        start(param) {
            this.$router.push({
                name: `graduate-work-${param}`,
                params: {
                    graduateWorkId: this.currentItem.id,
                    item: this.$route.params.item,
                },
            });
        },
        checkStatusTest() {
            if (this.currentItem.userGraduateWork.data.hasOwnProperty("status")) {
                switch (this.currentItem.userGraduateWork.data.status) {
                    case "processing": {
                        break;
                    }
                    case "canceled": {
                        break;
                    }
                    case "new": {
                        break;
                    }
                    case "on_checking": {
                        try {
                            this.$router.push({
                                name: "graduate-work-check",
                                params: {
                                    graduateWorkId: this.currentItem.id,
                                    item: this.$route.params.item,
                                },
                            });
                        } catch (e) {
                            console.log(e);
                        }
                        break;
                    }
                    default: {
                        try {
                            this.$router.push({
                                name: "graduate-work-report",
                                params: {
                                    graduateWorkId: this.currentItem.id,
                                    item: this.$route.params.item,
                                },
                            });
                        } catch (e) {
                            console.log(e);
                        }
                        break;
                    }
                }
            }
        },
    },
    destroyed() {
        this.changeHeader({
            show: false,
            title: "",
            currentTime: "",
            availableTime: "",
            parentRoute: "",
        });
    },
};
